import { fetchAuthSession } from 'aws-amplify/auth'

const service = async () => {

    const session = await fetchAuthSession()
    const idTokenPayload = session.tokens?.idToken?.payload
    const scopesString = idTokenPayload?.["custom:scopes"]
    const scopes = scopesString?.split(",")

    const role = idTokenPayload?.["custom:role"]

    const companyId = idTokenPayload?.["custom:companyId"]

    const userId = idTokenPayload?.["custom:userId"]

    const givenName = idTokenPayload?.["given_name"]
    const familyName = idTokenPayload?.["family_name"]
    const email = idTokenPayload?.email

    return {
        scopes,
        role,
        userId,
        givenName,
        familyName,
        email,
        companyId,
    }
}

export default service
